import React from 'react';

import { StyledLabel } from './Label.styled';

export type Props = React.LabelHTMLAttributes<HTMLLabelElement>;

const Label: React.FC<Props> = props => {
    return <StyledLabel {...props} />;
};

export default Label;
